import {NavLink, useNavigate, useLocation} from 'react-router-dom';
import ButDarkMode from "../Buttons/buttonDarMode/ButDarkMode";
import {HandySvg} from "handy-svg";

import AnixLogo from "./img/AnixLogo.svg"
import AnixLogoMobile from "./img/AnixLogoMobile.svg"
import logoutSVG from "./img/logout.svg"

import "./StyleHeader.css"
import {useState, useEffect, useCallback} from "react";
import {
    AUTH_PAGE,
    SEARCH_CONTAINER,
    getAvailableRoutes,
} from "../../utils/js/Const";
import BurgerButton from "../Buttons/buttonBergerMenu/ButtonBurgerMenu";
import BurgerMenu from "../Buttons/buttonBergerMenu/BurgerMenu";
import {decodeTokens, deleteCookie} from "../../utils/js/request";
import {useNotifications} from "../../providers/notificationProvider/NotificationProvider";
import {useIsMobile} from "../../utils/hooks/useIsMobile/useIsMobile";

function Header({ onLogout }) {
    decodeTokens();
    const location = useLocation();
    const navigate = useNavigate();
    const isMobile = useIsMobile();

    const { notifications, getTotalCount } = useNotifications();

    const totalCount = getTotalCount();
    const productOffersCount = notifications.productOffers || 0;
    const claimsCount = notifications.claims || 0;
    const ordersCount = notifications.orders || 0;


    const [isOpen, setIsOpen] = useState(false);

    const [availableRoutes, setAvailableRoutes] = useState([]);
    const [isInitialized, setIsInitialized] = useState(false);

    const updateAvailableRoutes = useCallback(() => {
        const role = localStorage.getItem('ROLE');

        try {
            const rolesJson = localStorage.getItem('USER_ROLES');
            let parsedRoles = [];
            if (rolesJson) {
                parsedRoles = JSON.parse(rolesJson);
            }

            const routes = getAvailableRoutes(parsedRoles, role);

            setAvailableRoutes(routes);
            setIsInitialized(true);

        } catch (e) {
            console.error('Ошибка парсинга ролей:', e);
        }
    }, []);

    useEffect(() => {
        updateAvailableRoutes();

        window.addEventListener('storage', updateAvailableRoutes);

        const interval = setInterval(updateAvailableRoutes, 2000);

        return () => {
            window.removeEventListener('storage', updateAvailableRoutes);
            clearInterval(interval);
        };
    }, [updateAvailableRoutes]);

    const handleClick = () => {
        setIsOpen(!isOpen);
    };

    const Logout = async () => {
        localStorage.clear();
        sessionStorage.clear();
        deleteCookie("access_token");
        await new Promise((resolve) => setTimeout(resolve, 1000));
        onLogout();
        navigate(AUTH_PAGE);
        window.location.reload();
    };

    const isActive = (path) => {
        return location.pathname === path;
    };

    if (!isInitialized) {
        return null;
    }

    return (
        <header>
            <div className="header--container">
                <NavLink to={SEARCH_CONTAINER} className="logo__mobile">
                    <img src={AnixLogoMobile} alt="Логотип сайта слово Аникс" />
                </NavLink>
                <NavLink to={SEARCH_CONTAINER}>
                    <img src={AnixLogo} alt="Логотип сайта слово Аникс" className="logo" />
                </NavLink>

                <ul className="header--container--list">
                    {availableRoutes.map((route, index) => (
                        <li
                            key={route.path}
                            className={isActive(route.path) ? "header--container--position header--container--position__active" : "header--container--position"}
                        >
                            <NavLink to={route.path}>
                                {route.name}
                            </NavLink>
                            {productOffersCount > 0 && index === 3 ? (
                                <div className={`header_count ${isOpen ? "hidden" : ""}`}>
                                    {isMobile ? "" : productOffersCount}
                                </div>
                            ) : ""}
                            {claimsCount > 0 && index === 4 ? (
                                <div className={`header_count ${isOpen ? "hidden" : ""}`}>
                                    {isMobile ? "" : claimsCount}
                                </div>
                            ) : ""}
                            {ordersCount > 0 && index === 5 ? (
                                <div className={`header_count ${isOpen ? "hidden" : ""}`}>
                                    {isMobile ? "" : ordersCount}
                                </div>
                            ): ""}
                        </li>
                    ))}
                </ul>

                <div className="header--container--bellAndButDarkMode">
                    <div className="header--logout--svg" onClick={Logout}>
                        <HandySvg src={logoutSVG} style={{width: "2dvw", height: "1dvw"}} className="logout"/>
                    </div>
                    <ButDarkMode />
                </div>
            </div>

            <BurgerButton
                isOpen={isOpen}
                onClick={handleClick}
                productsCount={totalCount}
            />
            <BurgerMenu
                isOpen={isOpen}
                onClick={handleClick}
                logout={onLogout}
                productOffersCount={productOffersCount}
                claimsCount={claimsCount}
                ordersCount={ordersCount}
            />
        </header>
    );
}

export default Header;
